import React, {Component} from "react";
import {Field, formValueSelector, reduxForm} from "redux-form";
import {connect} from "react-redux";
import * as actions from "../../actions/index";
import {checkBroadcasterAvialability, isChecked, priceList,} from "../../util/broadcaster/profile_util";
import {renderField, renderTextAreaField,} from "../../util/account_management";
import moment from "moment";
import {EmailShareButton, FacebookShareButton, TwitterShareButton, WhatsappShareButton,} from "react-share";
import {hideModal, isEmpty, navigate, removeWordFromList, required, showModal, vuepayAlert,} from "../../util/utility";
import {getData, LOGIN} from "../../util/storage";
import MessageUser from "../../components/MessageUser";
import YotiConfirmModal from "../../components/modal/YotiModal";
import ConfirmationModal from "../../components/modal/ConfirmationModal";
import {subscribeToFireStoreForTipGoal, unsubscribeToFireStore,} from "../../util/firebase/firestore";
//image
import loading_white from "../../assets/gif/loading_blue.gif";
import information from "../../assets/images/information.svg";
import closeAvailability from "../../assets/images/end-availability.svg";
import shareAvailability from "../../assets/images/share-availability.svg";

import setHours from "date-fns/setHours";
import getHours from "date-fns/getHours";
import setMinutes from "date-fns/setMinutes";
import getMinutes from "date-fns/getMinutes";
import addMinutes from "date-fns/addMinutes";
import {Tooltip} from "reactstrap";
import {
    getEndTimeMaxDate,
    getEndTimeMaxTime,
    getEndTimeMinDate, getEndTimeMinTime,
    getMaximumTimeForEndTime,
    getMinimumTimeForEndTime
} from "../../util/broadcast/availability";

// Tip goal size
const STEP = 1;
const MIN = 10;
const MAX = 10000;

class CreateBroadcastAvailability extends Component {
    constructor() {
        super();

        this.state = {
            count: 0,
            purpose_of_tip_count: 0,
            titleCount: 0,
            broadcast_type: "free",
            broadcast_session_type: "free",
            optionTemplate: priceList().map((v) => (
                <option key={v} value={v}>
                    {parseFloat(v / 100).toFixed(2)}
                </option>
            )),
            userDataForMessage: null,
            isVisible: false,
            messageAllData: null,
            requireStream: false,
            yotiModalStatus: false,
            shareList: [],
            isAvailabilityExist: false,
            oneToOneAllowed: false,
            closeTooltipOpen: false,
            tip_goal_amount: 10,
            tipGoalData: null,
            isTipGoalExist: false,
        };

        //all the functions used in this component should be listed here for better documentation
        this.onSubmit = this.onSubmit.bind(this);
        this.toggle = this.toggle.bind(this);
        this.toggleOneToOne = this.toggleOneToOne.bind(this);
        this.textAreaChange = this.textAreaChange.bind(this);
    }

    // Tooltip
    closeToggle = () => {
        this.setState({closeTooltipOpen: !this.state.closeTooltipOpen});
    };

    // --/-- //

    componentDidMount() {
        this.props.showLeftBar(); //hide the leftbar

        this.setState({
            isAvailabilityExist: this.isAvailabilityExist(),
            oneToOneAllowed: this.isOneToOneAllowed(),
            isTipGoalExist: this.isTipGoalExist(),
        });
        // this.props.dispatch(
        //   this.props.change("tip_goal_amount", this.state.tip_goal_amount.toString())
        // ); // tip goal amount

        if (
            checkBroadcasterAvialability(this.props.account_management.userDetails) &&
            this.props.tip_amount
        ) {

            //   this.props.dispatch(
            //     this.props.change("tip_goal_amount", this.props.tip_amount)
            //   );
            let temp_value = [];
            this.props.tip_amount && temp_value.push(this.props.tip_amount);

            this.props.tip_amount &&
            this.setState({
                tip_goal_amount: temp_value,
            });
        } else {

            this.props.dispatch(
                this.props.change("tip_goal_amount", this.state.tip_goal_amount)
            );
        }
        if (
            !checkBroadcasterAvialability(this.props.account_management.userDetails)
        ) {
            this.props.dispatch(this.props.change("broadcast_type", "free"));
            this.props.dispatch(this.props.change("age_group", "less_than_12"));
            this.props.dispatch(this.props.change("broadcast_session_type", "free"));
        } else {
            this.setState({
                titleCount: this.props.initialValues
                    ? this.props.initialValues.session_title.length
                    : 0,
                count: this.props.initialValues
                    ? this.props.initialValues.session_description.length
                    : 0,
            });
        }
        this.setState({
            broadcast_session_type:
            this.props.initialValues &&
            this.props.initialValues.broadcast_session_type,
            broadcast_type:
            this.props.initialValues && this.props.initialValues.broadcast_type,
        });
        // this.props.dispatch(this.props.change("broadcast_session_type",this.props.initialValues && this.props.initialValues.broadcast_session_type))

        document.getElementsByClassName("modal-overlay")[0].style.display = "none";

        //every time the create broadcast is loaded we check if the user api_token and token is available
        //it the api_token and token is available we do hit getUserDetails Webservice
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                this.props.getUserDetails(data.token, data.api_token);
            }
        });
        window.scrollTo(0, 0);
    }

    isBroadcasterVerified = () => {
        return (
            this.props.account_management.userDetails !== null &&
            this.props.account_management.userDetails !== undefined &&
            this.props.account_management.userDetails.hasOwnProperty("broadcaster") &&
            this.props.account_management.userDetails.broadcaster.length > 0 &&
            this.props.account_management.userDetails.broadcaster[0].is_verified === 1
        );
    };

    isAvailabilityExist = () => {

        return (
            this.props.account_management.userDetails !== null &&
            this.props.account_management.userDetails !== undefined &&
            this.props.account_management.userDetails.hasOwnProperty("broadcaster") &&
            this.props.account_management.userDetails.broadcaster.length > 0 &&
            this.props.account_management.userDetails.broadcaster[0].availability
                .length > 0
        );
    };

    isTipGoalExist = () => {
        return (
            this.props.account_management.userDetails !== null &&
            this.props.account_management.userDetails !== undefined &&
            this.props.account_management.userDetails.hasOwnProperty("broadcaster") &&
            this.props.account_management.userDetails.broadcaster.length > 0 &&
            this.props.account_management.userDetails.broadcaster[0].availability
                .length > 0 &&
            this.props.account_management.userDetails.broadcaster[0].availability[0]
                .tip_goal.length > 0
        );
    };

    isOneToOneAllowed = () => {
        return (
            this.props.account_management.userDetails !== null &&
            this.props.account_management.userDetails !== undefined &&
            this.props.account_management.userDetails.hasOwnProperty("broadcaster") &&
            this.props.account_management.userDetails.broadcaster.length > 0 &&
            this.props.account_management.userDetails.broadcaster[0].availability
                .length > 0 &&
            this.props.account_management.userDetails.broadcaster[0].availability[0]
                .one_to_one_session_allow
        );
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            shareList: [
                <FacebookShareButton
                    url={`https://www.vuepay.com/broadcast/YnJvYWRjYXN0ZXJfYnJvYWRjYXN0XzMyNA==`}
                    quote={"Share me"}
                    style={{width: 40, height: 40}}
                >
                    <div className="facebookicon"></div>
                </FacebookShareButton>,
                <WhatsappShareButton
                    url={`https://www.vuepay.com/broadcast/YnJvYWRjYXN0ZXJfYnJvYWRjYXN0XzMyNA==`}
                    quote={"Share me"}
                    style={{width: 40, height: 40}}
                >
                    <div className="whatsappicon"></div>
                </WhatsappShareButton>,
                <TwitterShareButton
                    url={`https://www.vuepay.com/broadcast/YnJvYWRjYXN0ZXJfYnJvYWRjYXN0XzMyNA==`}
                    quote={"Share me"}
                    style={{width: 40, height: 40}}
                >
                    <div className="twittericon"></div>
                </TwitterShareButton>,
                <EmailShareButton
                    url={`https://www.vuepay.com/broadcast/YnJvYWRjYXN0ZXJfYnJvYWRjYXN0XzMyNA==`}
                    quote={"Share me"}
                    style={{width: 40, height: 40}}
                >
                    <div className="emailicon"></div>
                </EmailShareButton>,
            ],
        });
        if (nextProps.availability && nextProps.availability.payload) {
            //if the status_code received from the server is 200 means the user has successfully done the forgot password
            if (
                nextProps.availability.payload.status_code === 200 ||
                nextProps.availability.payload.status_code === 201
            ) {
                getData(LOGIN).then((data) => {
                    if (!isEmpty(data)) {
                        this.props.getUserDetails(data.token, data.api_token);
                    }
                });
                nextProps.resetAvailability();
                vuepayAlert("success", nextProps.availability.payload.message);
                navigate(this.props, "broadcaster_availability");
            } else {
                //if the status_code received from the server is NOT 200 means there has been some error occurred
                nextProps.resetAvailability();
                vuepayAlert("error", nextProps.availability.payload.message);
            }
        }

        if (
            nextProps.account_management &&
            nextProps.account_management.userDetails &&
            nextProps.account_management.userDetails.broadcaster[0].availability[0]
        ) {

            let tip_goal = getTipGoal(nextProps);
            if(tip_goal.hasOwnProperty("tip_goal_id")){
                /**
                 * @business_rule
                 * listener for tip_goal
                 */
                return subscribeToFireStoreForTipGoal(
                    nextProps.account_management.userDetails.broadcaster[0].availability[0].broadcast[0].id.toString(),
                    nextProps.account_management.userDetails.broadcaster[0].availability[0]
                        .tip_goal[0].tip_goal_id,
                    this.onRequestTipGoalData
                );
            }
        }
    }

    onRequestTipGoalData = (querySnapshot) => {
        let tipGoalData = [];
        this.setState({
            tipGoalData: querySnapshot.data(),
        });
    };

    navCreateBroadcast = () => {
        this.setState({
            yotiModalStatus: false,
        });
        navigate(this.props, "broadcaster_create_availability");
    };

    onSubmit(values) {
        const formData = {
            session_title: values.session_title,
            session_description: values.session_description,
            age_group: values.age_group,
            broadcast_type: values.broadcast_type,
            one_to_one_session_allow: isChecked("one_to_one_session_allow"),
            one_to_one_session_price: parseInt(
                document.getElementsByName("one_to_one_session_price")[0].value
            ),
            group_session_price:
                this.state.broadcast_type === "free"
                    ? 0
                    : parseInt(
                    document.getElementsByName("group_session_price")[0].value
                    ),
            is_chat_allowed: true,
            is_share_stream: values.is_share_stream,
            live_recording_to_library: values.live_recording_to_library,
            youtube_live_url: values.youtube_live_url,
            facebook_live_url: values.facebook_live_url,
            device: this.props.device,
            availability_start_at: moment.utc().format("YYYY-MM-DD HH:mm:ss"),
            availability_end_at: moment(values.end_time).utc().format("YYYY-MM-DD HH:mm:ss"),
        };

        if (values.is_tip_goal_allowed) {
            formData["is_tip_goal_allowed"] = values.is_tip_goal_allowed;
            formData["tip_goal_purpose"] = values.tip_goal_purpose;
            formData["tip_goal_amount"] = 100 * this.state.tip_goal_amount;
        }

        //dispatch an action to POST the channel picture/image to the Webservice
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                checkBroadcasterAvialability(this.props.account_management.userDetails)
                    ? this.props.updateAvailability(
                    data.token,
                    data.api_token,
                    formData,
                    this.props.account_management &&
                    this.props.account_management.userDetails.broadcaster[0]
                        .availability[0].id
                    )
                    : this.props.createAvailability(data.token, data.api_token, formData);
            }
        });
    }

    requestCloseAvailability = () => {
        const modal = document.getElementById("availability-close-confirmation");
        showModal(modal);
    };

    submitCloseAvailability = () => {
        const modal = document.getElementById("availability-close-confirmation");
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                checkBroadcasterAvialability(
                    this.props.account_management.userDetails
                ) &&
                unsubscribeToFireStore(
                    this.props.account_management &&
                    this.props.account_management.userDetails.broadcaster.length >
                    0 &&
                    this.props.account_management.userDetails.broadcaster[0]
                        .availability.length > 0 &&
                    this.props.account_management.userDetails.broadcaster[0]
                        .availability[0].broadcast.length > 0 &&
                    this.props.account_management.userDetails.broadcaster[0].availability[0].broadcast[0].id.toString()
                );
                checkBroadcasterAvialability(
                    this.props.account_management.userDetails
                ) &&
                this.props.closeAvailability(
                    data.token,
                    data.api_token,
                    this.props.account_management &&
                    this.props.account_management.userDetails.broadcaster[0]
                        .availability[0].id
                );
                this.props.resetAvailabilityList();
            }
        });
        hideModal(modal);
    };

    callYotiIntegration = () => {
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                this.props.yotiIntegration(data.token, data.api_token);
                this.setState({
                    yotiModalStatus: true,
                });
            }
        });
    };

    toggle(_type) {
        this.setState(
            {
                broadcast_type: _type,
            },
            () => {
                const index = _type === "free" ? 0 : 1,
                    target = document.getElementsByClassName("broadcast_type")[index],
                    oppositeIndex = _type === "free" ? 1 : 0,
                    oppositeTarget = document.getElementsByClassName("broadcast_type")[
                        oppositeIndex
                        ];

                if (target.classList.contains("active")) {
                    target.classList.remove("active");
                } else {
                    oppositeTarget.classList.remove("active");
                    target.classList.add("active");
                }
            }
        );
    }

    toggleOneToOne(_type) {
        this.setState({
            broadcast_type_onetoone: _type,
        });
    }

    handleOnBlur = (event, newValue, previousValue, name) => {
        setTimeout(() => {
            const newData = removeWordFromList(
                this.props.account_management &&
                this.props.account_management.userDetails.broadcaster[0].id,
                this.props.profanity,
                newValue,
                true,
                false
            );
            this.props.dispatch(this.props.change(name, newData));
            name === "session_title" &&
            this.setState({
                titleCount: newData.length,
            });
        }, 0);
    };


    handleKeyPressTipGoalAmount = (e) => {
        this.setState({
            tip_goal_amount: e.target.value
        })
    }

    /**
     * @function listener for text area change we use this to maintain the count of the characters the user has typed
     * @param e
     */
    textAreaChange(event, newValue, previousValue, name) {
        setTimeout(() => {
            const newData = removeWordFromList(
                this.props.account_management &&
                this.props.account_management.userDetails.broadcaster[0].id,
                this.props.profanity,
                newValue,
                true,
                false
            );
            this.props.dispatch(this.props.change(name, newData));

            name != "tip_goal_purpose"
                ? this.setState({
                    count: newData.length,
                })
                : this.setState({
                    purpose_of_tip_count: newData.length,
                });
        }, 0);
    }

    toggleVisibilityOfMessage = () => {
        this.setState({isVisible: !this.state.isVisible});
    };

    handleChangeBroadcastType = (event, newValue, previousValue, name) => {
        if (!this.isBroadcasterVerified() && newValue === "paid") {
            const modal = document.getElementById("common-modal");
            showModal(modal);
        } else {
            this.props.dispatch(this.props.change("is_share_stream", false));
            this.props.dispatch(this.props.change("live_recording_to_library", false));
            this.props.dispatch(this.props.change("facebook_live_url", ""));
            this.props.dispatch(this.props.change("youtube_live_url", ""));
            this.setState({
                broadcast_type: newValue,
            });
        }
    };

    updateBroadcastType = () => {
        this.props.dispatch(this.props.change("broadcast_type", "free"));
        this.props.dispatch(this.props.change("broadcast_session_type", "free"));

        this.setState({
            broadcast_type: "free",
            broadcast_session_type: "free",
        });
    };

    handleChangeBroadcastSessionType = (event, newValue, previousValue, name) => {
        if (!this.isBroadcasterVerified() && newValue === "paid") {
            const modal = document.getElementById("common-modal");
            showModal(modal);
        } else {
            this.setState({
                broadcast_session_type: newValue,
            });
        }
    };

    handleChangeStrem = (event, newValue, previousValue, name) => {
        newValue
            ? this.setState({
                requireStream: false,
            })
            : this.setState({
                requireStream: true,
            });
    };

    render() {

        const {handleSubmit} = this.props;

        return (
            <div>
                <main role="main" className="">
                    <div className="broadcast-container-parent row">
                        <div className="broadcast-container broadcast-type">
                            {
                                checkBroadcasterAvialability(this.props.account_management.userDetails) && (
                                    <div className="row">
                                        <div className="col-md-12 text-right">
                                            <span className={"popover__wrapper"}>
                                              <button
                                                  className="btn btn-light rounded-0 share-availability"
                                                  type="button"
                                              >
                                                <img
                                                    className="share-availability-icon"
                                                    src={shareAvailability}
                                                />
                                              </button>
                                              <div className={"popover_share_content"}>
                                                <ul
                                                    className="popover_menucontent"
                                                    aria-labelledby="myDropdown"
                                                >
                                                  {this.state.shareList &&
                                                  this.state.shareList.map((shareData,index) => {
                                                      return (
                                                          <li style={{display: "inline-block"}} key={`share-list-${index}`}>
                                                              <a>{shareData}</a>
                                                          </li>
                                                      );
                                                  })}
                                                </ul>
                                              </div>
                                            </span>
                                            <button id="close" className="btn btn-light rounded-0 share-availability"
                                                    onClick={() => this.requestCloseAvailability()}>
                                                <img className="close-availability-icon" src={closeAvailability}/>
                                            </button>
                                            <Tooltip placement="top"
                                                     isOpen={this.state.closeTooltipOpen}
                                                     autohide={false}
                                                     target="close"
                                                     toggle={this.closeToggle}>
                                                Close Availability!
                                            </Tooltip>
                                        </div>
                                    </div>
                                )
                            }

                            <div className="wrapper">
                                {
                                    <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                                        <dl className="row">

                                            {/*Enter session title*/}
                                            <dt className="col-sm-3">Enter session title</dt>
                                            <dd className="col-sm-9">
                                                <Field
                                                    label=""
                                                    name="session_title"
                                                    type="text"
                                                    maxLength="40"
                                                    count={this.state.titleCount}
                                                    onBlur={this.handleOnBlur}
                                                    onChange={this.handleOnBlur}
                                                    height={"32px"}
                                                    username={null}
                                                    validate={[required]}
                                                    component={renderField}
                                                />
                                            </dd>
                                            {/*Enter session title*/}

                                            {/*Enter session description*/}
                                            <dt className="col-sm-3">Enter session description</dt>
                                            <dd className="col-sm-9">
                                                <Field
                                                    label=""
                                                    name="session_description"
                                                    maxLength="280"
                                                    minLength="1"
                                                    onBlur={this.textAreaChange}
                                                    height={"153px"}
                                                    count={this.state.count}
                                                    validate={[required]}
                                                    component={renderTextAreaField}
                                                    onChange={this.textAreaChange}
                                                />
                                            </dd>
                                            {/*Enter session description*/}

                                            {/*Start Time*/}
                                            <dt className="col-sm-3">Start Time</dt>
                                            <dd className="col-sm-9">
                                                <Field
                                                    label=""
                                                    name="start_time"
                                                    height={"32px"}
                                                    username={null}
                                                    value={new Date()}
                                                    isDatePicker={true}
                                                    minDate={new Date()}
                                                    maxDate={moment(new Date()).add(1, "days").toDate()}
                                                    minTime={
                                                        this.props.start_time > moment(new Date()).utc()
                                                            ? setHours(setMinutes(new Date(), 30), 0)
                                                            : setHours(
                                                            setMinutes(new Date(), getMinutes(new Date())),
                                                            getHours(new Date())
                                                            )
                                                    }
                                                    maxTime={setHours(setMinutes(new Date(), 30), 23)}
                                                    validate={null}
                                                    component={renderField}
                                                    disabledDatePicker={true}
                                                />
                                            </dd>
                                            {/*Start Time*/}

                                            {/*End Time*/}
                                            <dt className="col-sm-3">End Time</dt>
                                            <dd className="col-sm-9">
                                                <div className="form-group">
                                                    <Field
                                                        label=""
                                                        name="end_time"
                                                        height={"32px"}
                                                        username={null}
                                                        value={null}
                                                        minDate={getEndTimeMinDate(this.props)}
                                                        maxDate={getEndTimeMaxDate(this.props)}
                                                        isDatePicker={true}
                                                        minTime={getEndTimeMinTime(this.props)}
                                                        maxTime={getEndTimeMaxTime(this.props)}
                                                        validate={[required]}
                                                        component={renderField}
                                                    />
                                                </div>
                                            </dd>
                                            {/*End Time*/}

                                            {/*Broadcast Type*/}
                                            <dt className="col-sm-3">Broadcast Type</dt>
                                            <dd className="col-sm-9">
                                                <div className="form-group">
                                                    <label className="broadcastType">
                                                        <Field
                                                            name="broadcast_type"
                                                            component="input"
                                                            type="radio"
                                                            value="free"
                                                            onChange={this.handleChangeBroadcastType}
                                                            disabled={this.state.isAvailabilityExist}
                                                        />{" "}
                                                        Free
                                                    </label>
                                                    <label className="broadcastType">
                                                        <Field
                                                            name="broadcast_type"
                                                            component="input"
                                                            type="radio"
                                                            value="paid"
                                                            onChange={this.handleChangeBroadcastType}
                                                            disabled={this.state.isAvailabilityExist}
                                                        />{" "}
                                                        Paid
                                                    </label>
                                                </div>
                                            </dd>
                                            {/*Broadcast Type*/}

                                            {/*Allow 1 on 1 sessions*/}
                                            <dt className="col-sm-3">Allow 1 on 1 sessions</dt>
                                            <dd className="col-sm-9">
                                                <label className="checkbox">
                                                    <Field
                                                        name="one_to_one_session_allow"
                                                        component="input"
                                                        type="checkbox"
                                                        disabled={
                                                            this.state.oneToOneAllowed &&
                                                            this.state.isAvailabilityExist
                                                        }
                                                    />
                                                    <span className="checkmark"/>
                                                </label>
                                            </dd>
                                            {/*Allow 1 on 1 sessions*/}

                                            {/*1 on 1 session type*/}
                                            <dt className={this.props.oneToOne ? "col-sm-3 thing-enter" : "col-sm-3 thing-leave"}>
                                                1 on 1 session type
                                            </dt>
                                            <dd className={this.props.oneToOne ? "col-sm-9 thing-enter" : "col-sm-9 thing-leave"}>
                                                <div className="form-group">
                                                    <label className="broadcastType">
                                                        <Field
                                                            name="broadcast_session_type"
                                                            component="input"
                                                            type="radio"
                                                            value="free"
                                                            disabled={this.state.oneToOneAllowed && this.state.isAvailabilityExist}
                                                            onChange={this.handleChangeBroadcastSessionType}
                                                        />{" "}
                                                        Free
                                                    </label>
                                                    <label className="broadcastType">
                                                        <Field
                                                            name="broadcast_session_type"
                                                            component="input"
                                                            type="radio"
                                                            value="paid"
                                                            disabled={
                                                                this.state.oneToOneAllowed &&
                                                                this.state.isAvailabilityExist
                                                            }
                                                            onChange={this.handleChangeBroadcastSessionType}
                                                        />{" "}
                                                        Paid
                                                    </label>
                                                </div>
                                            </dd>
                                            {/*1 on 1 session type*/}

                                            {/*Set 1 on 1 price*/}
                                            <dt className={isChecked("one_to_one_session_allow") && this.state.broadcast_session_type !== "free" ? "col-sm-3 thing-enter" : "col-sm-3 thing-leave"}>
                                                Set 1 on 1 price
                                            </dt>
                                            <dd className={isChecked("one_to_one_session_allow") && this.state.broadcast_session_type !== "free" ? "col-sm-9 thing-enter" : "col-sm-9 thing-leave"}>
                                                <Field className="custom-select"
                                                       name="one_to_one_session_price"
                                                       component="select"
                                                       disabled={this.state.oneToOneAllowed && this.state.isAvailabilityExist}>

                                                    {this.state.broadcast_session_type === "free" ? (
                                                        <option key={0.0} value={0.0}>
                                                            0.00
                                                        </option>
                                                    ) : (
                                                        this.state.optionTemplate
                                                    )}
                                                </Field>
                                                <span>£/min</span>
                                            </dd>
                                            {/*Set 1 on 1 price*/}

                                            {/*Set group price*/}
                                            <dt className={this.state.broadcast_type === "paid" ? "col-sm-3 thing-enter" : "col-sm-3 thing-leave"}>
                                                Set group price
                                            </dt>
                                            <dd className={this.state.broadcast_type === "paid" ? "col-sm-9 thing-enter" : "col-sm-9 thing-leave"}>
                                                <Field
                                                    className="custom-select"
                                                    name="group_session_price"
                                                    component="select"
                                                    disabled={this.state.isAvailabilityExist}>
                                                    {this.state.optionTemplate}
                                                </Field>
                                                <span>£/min</span>
                                            </dd>
                                            {/*Set group price*/}

                                            {/*Age rating*/}
                                            <dt className="col-sm-3">
                                                Age rating
                                                <a href="https://www.bbfc.co.uk/about-classification/classification-guidelines"
                                                   target="_blank">
                                                    <img alt={"close-icon"} width="18" src={information}/>
                                                </a>
                                            </dt>
                                            <dd className="col-sm-9">
                                                <div className="form-group">
                                                    <label className="ageGroup">
                                                        <Field
                                                            name="age_group"
                                                            component="input"
                                                            type="radio"
                                                            value="less_than_12"
                                                        />{" "}
                                                        Under 12
                                                    </label>
                                                    <label className="ageGroup">
                                                        <Field
                                                            name="age_group"
                                                            component="input"
                                                            type="radio"
                                                            value="more_than_12"
                                                        />{" "}
                                                        12+
                                                    </label>
                                                    <label className="ageGroup">
                                                        <Field
                                                            name="age_group"
                                                            component="input"
                                                            type="radio"
                                                            value="more_than_15"
                                                        />{" "}
                                                        15+
                                                    </label>
                                                    <label className="ageGroup">
                                                        <Field
                                                            name="age_group"
                                                            component="input"
                                                            type="radio"
                                                            value="18"
                                                        />{" "}
                                                        18
                                                    </label>
                                                </div>
                                            </dd>
                                            {/*Age rating*/}

                                            {/*Tip Goal*/}
                                            <dt className="col-sm-3">Like Goal</dt>
                                            <dd className="col-sm-9">
                                                <label className="checkbox">
                                                    <Field
                                                        name="is_tip_goal_allowed"
                                                        component="input"
                                                        type="checkbox"
                                                        disabled={this.state.isTipGoalExist}
                                                    />
                                                    <span className="checkmark"/>
                                                </label>
                                            </dd>
                                            {/*Tip Goal*/}

                                            {/*Tip Goal Amount*/}
                                            <dt className={this.props.tip_goal ? "col-sm-3 thing-enter" : "col-sm-3 thing-leave"}>
                                                Like Goal Amount
                                            </dt>
                                            <dd className={this.props.tip_goal ? "col-sm-9 thing-enter" : "col-sm-9 thing-leave"}>

                                                <Field
                                                    label="Please enter a value between £1 and £10k"
                                                    name="tip_goal_amount"
                                                    type="number"
                                                    onChange={this.handleKeyPressTipGoalAmount}
                                                    height={"3CreateBroadcastAvailability2px"}
                                                    username={null}
                                                    component={renderField}
                                                    hideMaxLength
                                                    min={1}
                                                    max={10000}
                                                    validate={this.props.tip_goal && [required]}
                                                />
                                            </dd>
                                            {/*Tip Goal Amount*/}

                                            {/*Purpose of Like*/}
                                            <dt className={this.props.tip_goal ? "col-sm-3 thing-enter" : "col-sm-3 thing-leave"}>
                                                Purpose of Like
                                            </dt>
                                            <dd className={this.props.tip_goal ? "col-sm-9 thing-enter" : "col-sm-9 thing-leave"}>
                                                <div className="form-group">
                                                    <Field
                                                        label=""
                                                        name="tip_goal_purpose"
                                                        maxLength="500"
                                                        minLength="1"
                                                        onBlur={this.textAreaChange}
                                                        height={"124px"}
                                                        count={this.state.purpose_of_tip_count}
                                                        validate={this.props.tip_goal && [required]}
                                                        component={renderTextAreaField}
                                                        onChange={this.textAreaChange}
                                                        disabled={this.state.isTipGoalExist}
                                                    />
                                                </div>
                                            </dd>
                                            {/*Purpose of Like*/}

                                            {/*Share stream*/}
                                            <dt className={this.state.broadcast_type === "free" ? "col-sm-3 thing-enter" : "col-sm-3 thing-leave"}>
                                                Share stream
                                            </dt>
                                            <dd className={this.state.broadcast_type === "free" ? "col-sm-9 thing-enter" : "col-sm-3 thing-leave"}>
                                                <label className="checkbox">
                                                    <Field
                                                        name="is_share_stream"
                                                        component="input"
                                                        type="checkbox"
                                                    />
                                                    <span className="checkmark"/>
                                                </label>
                                            </dd>
                                            {/*Share stream*/}

                                            {/*YouTube Live url*/}
                                            <dt className={this.state.broadcast_type === "free" && this.props.share_stream ? "col-sm-3 thing-enter" : "col-sm-3 thing-leave"}>
                                                YouTube Live url
                                            </dt>
                                            <dd className={this.state.broadcast_type === "free" && this.props.share_stream ? "col-sm-9 thing-enter" : "col-sm-3 thing-leave"}>
                                                <Field
                                                    label=""
                                                    name="youtube_live_url"
                                                    type="text"
                                                    onChange={this.handleChangeStrem}
                                                    height={"32px"}
                                                    username={null}
                                                    validate={
                                                        this.props.share_stream &&
                                                        this.state.requireStream && [required]
                                                    }
                                                    maxLength={200}
                                                    component={renderField}
                                                    hideMaxLength
                                                />
                                            </dd>
                                            {/*YouTube Live url*/}

                                            {/*Facebook Live url*/}
                                            <dt className={this.state.broadcast_type === "free" && this.props.share_stream ? "col-sm-3 thing-enter" : "col-sm-3 thing-leave"}>
                                                Facebook Live url
                                            </dt>
                                            <dd className={this.state.broadcast_type === "free" && this.props.share_stream ? "col-sm-9 thing-enter" : "col-sm-3 thing-leave"}>
                                                <Field
                                                    label=""
                                                    name="facebook_live_url"
                                                    type="text"
                                                    onChange={this.handleChangeStrem}
                                                    height={"32px"}
                                                    username={null}
                                                    validate={
                                                        this.props.share_stream &&
                                                        this.state.requireStream && [required]
                                                    }
                                                    maxLength={200}
                                                    component={renderField}
                                                    hideMaxLength
                                                />
                                            </dd>

                                            {/*Add recording to library*/}
                                            <dt className="col-sm-3">Add recording to library</dt>
                                            <dd className="col-sm-9">
                                                <label className="checkbox">
                                                    <Field
                                                        name="live_recording_to_library"
                                                        component="input"
                                                        type="checkbox"
                                                    />
                                                    <span className="checkmark"/>
                                                </label>
                                            </dd>
                                            {/*Add recording to library*/}
                                        </dl>

                                        <div className="mt-4 text-right">
                                            {this.props.availability.isFetching ? (
                                                <button
                                                    className="btn btn-outline-primary w-100"
                                                    type="button"
                                                >
                                                    <img
                                                        src={loading_white}
                                                        alt={"Loading"}
                                                        width={26}
                                                        height={26}
                                                    />
                                                </button>
                                            ) : (
                                                <button className="btn btn-outline-primary w-100">
                                                    {checkBroadcasterAvialability(
                                                        this.props.account_management.userDetails
                                                    )
                                                        ? "Update Available"
                                                        : "Say Available!"}
                                                </button>
                                            )}
                                        </div>
                                    </form>
                                }
                            </div>
                        </div>

                        <MessageUser
                            isVisible={this.state.isVisible}
                            userData={this.state.userDataForMessage}
                            messageAllData={this.state.messageAllData}
                            closeMessage={this.toggleVisibilityOfMessage}
                        />

                        <YotiConfirmModal
                            isCreateProfile={false}
                            yotiModalStatus={this.state.yotiModalStatus}
                            callYotiIntegration={this.callYotiIntegration}
                            updateBroadcastType={this.updateBroadcastType}
                            updateType={true}
                            navCreateBroadcast={this.navCreateBroadcast}
                        />

                        <ConfirmationModal submitCloseAvailability={this.submitCloseAvailability}/>
                    </div>
                </main>
            </div>
        );
    }
}

function getAvailabilityPresent(state) {
    if (state.account_management.userDetails &&
        state.account_management.userDetails.hasOwnProperty("broadcaster") &&
        Array.isArray(state.account_management.userDetails.broadcaster) &&
        state.account_management.userDetails.broadcaster.length > 0 &&
        state.account_management.userDetails.broadcaster[0].hasOwnProperty("availability") &&
        Array.isArray(state.account_management.userDetails.broadcaster[0].availability) &&
        state.account_management.userDetails.broadcaster[0].availability.length > 0 &&
        state.account_management.userDetails.broadcaster[0].availability[0]) {
        return state.account_management.userDetails.broadcaster[0].availability[0];
    } else {
        return {};
    }
}

function getTipGoal(state) {
    const availability = getAvailabilityPresent(state);
    if (availability.hasOwnProperty("tip_goal") && Array.isArray(availability.tip_goal) && availability.tip_goal.length > 0) {
        return availability.tip_goal[0];
    } else {
        return {
            purpose: "",
            amount: 1000
        }
    }
}
function mapStateToProps(state) {
    const selector = formValueSelector("CreateBroadcastForm");
    const availability = getAvailabilityPresent(state);
    const tip_goal = getTipGoal(state);
    const userDetails = checkBroadcasterAvialability(state.account_management.userDetails);

    return {
        initialValues: {
            ...(getAvailabilityPresent(state)),
            start_time: userDetails && new Date(availability.availability_start_at),
            end_time: userDetails && new Date(availability.availability_end_at),
            is_tip_goal_allowed: tip_goal ? true : false,
            tip_goal_purpose:tip_goal.purpose,
            tip_goal_amount:tip_goal.amount/100,
            broadcast_session_type:userDetails && availability.one_to_one_session_price > 0 ? "paid" : "free",
        },
        // amount_formatted tip_goal_id id
        broadcast_type: selector(state, "broadcast_type"),
        share_stream: selector(state, "is_share_stream"),
        live_recording_to_library: selector(state, "live_recording_to_library"),
        tip_goal: selector(state, "is_tip_goal_allowed"),
        start_time: selector(state, "start_time"),
        end_time: selector(state, "end_time"),
        oneToOne: selector(state, "one_to_one_session_allow"),
        tip_goal_amount: selector(state, "tip_goal_amount"),
        account_management: state.account_management,
        broadcast: state.broadcast,
        availability: state.availability,
        device: state.device.payload,
        broadcaster_send_message: state.broadcaster_send_message,
        profanity: state.profanity.words,
        tip_amount:tip_goal.amount/100,
    };
}

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
CreateBroadcastAvailability = reduxForm({
    form: "CreateBroadcastForm", // a unique identifier for this form
    enableReinitialize: true,
})(CreateBroadcastAvailability);

// You have to connect() to any reducers that you wish to connect to yourself
CreateBroadcastAvailability = connect(
    mapStateToProps, // pull initial values from account reducer
    actions // bind account loading action creator
)(CreateBroadcastAvailability);

export default CreateBroadcastAvailability;
